"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "app-controlinput app-theme-bg",
    class: {
      'app-controlinput--focus': _vm.has_focus,
      'app-controlinput--show-send': _vm.shouldShowSendButton,
      'app-controlinput--show-tools': _vm.shouldShowTools,
      'app-controlinput--show-tools--inline': _vm.shouldShowToolsInline
    }
  }, [_c('div', {
    staticClass: "app-controlinput-inner"
  }, [_c('form', {
    staticClass: "app-controlinput-form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments);
      },
      "click": _vm.maybeHidePlugins
    }
  }, [_vm.autocomplete_open ? _c('auto-complete', {
    ref: "autocomplete",
    attrs: {
      "items": _vm.autocomplete_items,
      "filter": _vm.autocomplete_filter,
      "buffer": _vm.buffer
    },
    on: {
      "temp": _vm.onAutocompleteTemp,
      "selected": _vm.onAutocompleteSelected,
      "cancel": _vm.onAutocompleteCancel
    }
  }) : _vm._e(), _vm.showCommandWarning ? _c('div', {
    staticClass: "app-controlinput-command-warn"
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('input_not_command')) + " ")]), _c('div', {
    staticClass: "app-controlinput-command-text"
  }, [_vm._v(" " + _vm._s(_vm.$t('input_send_text')) + " "), _c('input-confirm', {
    attrs: {
      "flip-connotation": true
    },
    on: {
      "ok": function ($event) {
        return _vm.submitForm();
      },
      "submit": function ($event) {
        _vm.showCommandWarning = false;
      }
    }
  })], 1)]) : _vm._e(), _vm.buffer.setting('share_typing') ? _c('typing-users-list', {
    attrs: {
      "buffer": _vm.buffer
    }
  }) : _vm._e(), _c('div', {
    staticClass: "app-controlinput-input-wrap"
  }, [_c('irc-input', {
    ref: "input",
    staticClass: "app-controlinput-input",
    attrs: {
      "placeholder": _vm.$t('input_placeholder'),
      "wrap": "off"
    },
    on: {
      "input": _vm.inputUpdate,
      "keydown": function ($event) {
        return _vm.inputKeyDown($event);
      },
      "keyup": function ($event) {
        return _vm.inputKeyUp($event);
      },
      "click": _vm.closeToolsPlugins,
      "focus": _vm.focusChanged,
      "blur": _vm.focusChanged
    }
  })], 1)], 1), _vm.shouldShowTools ? _c('div', {
    ref: "plugins",
    staticClass: "app-controlinput-tools app-controlinput-tools-wrapper"
  }, [!_vm.shouldShowToolsInline ? _c('div', {
    staticClass: "app-controlinput-tools-expand app-controlinput-button",
    class: {
      'app-controlinput-tools-expand--closed': !_vm.showPlugins
    },
    on: {
      "click": function ($event) {
        _vm.showPlugins = !_vm.showPlugins;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _c('transition', {
    attrs: {
      "name": "app-plugin-ui-trans"
    }
  }, [_vm.showPlugins || _vm.shouldShowToolsInline ? _c('div', {
    staticClass: "app-controlinput-tools-container"
  }, [_vm.shouldShowColorPicker ? _c('div', {
    staticClass: "app-controlinput-button",
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.onToolClickTextStyle.apply(null, arguments);
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-adjust",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm.shouldShowEmojiPicker ? _c('div', {
    staticClass: "app-controlinput-button",
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.onToolClickEmoji.apply(null, arguments);
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-smile-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._l(_vm.pluginUiElements, function (plugin) {
    return _c(plugin.component, _vm._b({
      key: plugin.id,
      tag: "component",
      staticClass: "app-controlinput-button",
      attrs: {
        "plugin-props": {
          buffer: _vm.buffer,
          controlinput: _vm.self
        },
        "network": _vm.network,
        "buffer": _vm.buffer
      }
    }, 'component', plugin.props, false));
  })], 2) : _vm._e()])], 1) : _vm._e(), _vm.shouldShowSendButton ? _c('button', {
    ref: "sendButton",
    staticClass: "app-controlinput-button app-controlinput-send",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_c('span', {
    staticClass: "app-controlinput-send-text"
  }, [_vm._v("Envoyer")]), _c('i', {
    staticClass: "fa fa-paper-plane-o app-controlinput-send-icon",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()]), _c('div', {
    staticClass: "app-controlinput-active-tool"
  }, [_c(_vm.active_tool, _vm._b({
    tag: "component"
  }, 'component', _vm.active_tool_props, false))], 1)]);
};
var staticRenderFns = exports.staticRenderFns = [];